<template>
  <div style="min-height: calc(100vh - 160px)">
    <div class="title">
      <div v-if="singleData.docName" class="title--newFont">
        {{ singleData.docName }}
      </div>
      <div v-else class="title--newFont">付款账单详情</div>
      <div style="text-align: right">
        <el-button @click="backHome" size="mini">返回页面</el-button>
      </div>
    </div>
    <hr />
    <!-- 操作栏 -->
    <div style="margin-bottom: 10px">
      <label>账单单编号：</label>
      <span class="span">{{ singleData.purchasesStatementDocNumber }}</span>
      <label class="turnToPointer" @click="click_globalSearchNumber">全局搜索码</label>
      <span class="span turnToPointer" @click="click_globalSearchNumber">{{
        singleData.globalSearchNumber
      }}</span>
      <label>账单日期：</label>
      <span class="span">{{ formatDate(singleData.baseStatementDate) }}</span>
      <label>预付款日期：</label>
      <span class="span">{{ formatDate(singleData.baseExpectedPaymentDate) }}</span>
      <label>供应商名称：</label>
      <span class="span">{{ singleData.baseSupplierName }}</span>
      <label>供应商编号：</label>
      <span class="span">{{ singleData.baseSupplierNumber }}</span>
      <label>应付金额(折前)：</label>
      <span class="span">{{ singleData.baseShouldPaymentAmount }}</span>
      <label>应付金额(折后) ：</label>
      <span class="span">{{ singleData.baseShouldPaymentAmountDiscounted }}</span>
      <label>折扣率(%)：</label>
      <span class="span">{{ singleData.baseDiscount }}</span>
      <label>未付金额：</label>
      <span class="span">{{ singleData.valueUnpaidAmount }}</span>
      <label>已付金额：</label>
      <span class="span">{{ singleData.valuePaidAmount }}</span>
      <label>应开发票：</label>
      <span class="span">{{ singleData.baseShouldInvoiceAmount }}</span>
      <label>未开发票：</label>
      <span class="span">{{ singleData.valueUninvoicedAmount }}</span>
      <label>已开发票：</label>
      <span class="span">{{ singleData.valueInvoicedAmount }}</span>
      <label>请款金额：</label>
      <span class="span">{{ singleData.valueRequestFundsAmount }}</span>
      <div style="margin-top: 10px">
        <label>总金额：</label>
        <span class="span">{{ singleData.baseShouldPaymentAmount }}</span>
        <label>折扣金额：</label>
        <span v-if="singleData.statusCheck == 1" class="span">{{
          singleData.baseShouldPaymentAmountDiscounted
        }}</span>
        <el-input
          v-if="singleData.statusCheck == 0"
          v-model="singleData.baseShouldPaymentAmountDiscounted"
          @input="discountMoney()"
          size="mini"
          type="number"
          style="width: 120px"
        ></el-input>
        <label style="margin-left: 10px">折扣率(%)：</label>
        <span v-if="singleData.statusCheck == 1" class="span">{{
          singleData.baseDiscount
        }}</span>
        <el-input
          v-if="singleData.statusCheck == 0"
          v-model="singleData.baseDiscount"
          @input="discountRate()"
          size="mini"
          type="number"
          style="width: 120px"
        ></el-input>
        <el-button
          v-if="singleData.statusCheck == 0"
          size="mini"
          style="margin-left: 10px"
          @click="updateClick()"
          >保存</el-button
        >
      </div>
    </div>
    <!-- 内容 -->
    <div>
      <myTable
        :overflow="true"
        :id="'myTableOne'"
        :columnType="'columnIndex'"
        :list="itemList"
        :titleList="titleList"
        @resizableChange="resizableChange"
        :tableBtnList="itemTableBtnList"
        @excelOpen="excelOpen"
        @excelSuccess="excelSuccess"
        @cellClickEvent="cellClickEvent"
        :dialogStatus="1"
        ref="myTableOne"
      ></myTable>
    </div>
    <!-- 上传文件 -->
    <el-dialog
      :visible.sync="dialogState.show1"
      :close-on-click-modal="false"
      class="dialog"
      :title="dialogTitle"
      width="50%"
      @close="dialogClose"
    >
      <myUploadTable :list="tableList" :type="dialogType" :status="1"> </myUploadTable>
    </el-dialog>
  </div>
</template>
<script>
import {
  selcetSetting,
  updateSetting,
  mulFloat,
  customMenu,
  divFloat,
  accAdd,
  readUserSelect
} from '@/utils/myUtils';
import { setObjectToSessionStorage, getObjectFromSessionStorage } from '@/utils';
import { pmgtPurchasesReceiptDoc_getCooperativeSupplierPurchaseStatementDocView } from '@/api/myController/purchase';
export default {
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({})
    },
    homeIndex: {
      type: Number,
      default: false
    },
    modelType: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      purchasesStatementDocId: '',
      // 付款发票数据
      invoiceList: [],
      invoiceTitleList: [
        {
          id: 0,
          name: '公司名称', // 必传
          value: 'corporateName', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 0,
          name: '银行账号', // 必传
          value: 'supplierBankAccount', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 1,
          name: '税率%', // 必传
          value: 'taxRate', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
          width: 90
        },
        {
          id: 2,
          name: '税额', // 必传
          value: 'taxAmount', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'priceAccuracy', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 3,
          name: '未税金额', // 必传
          value: 'unTaxAmount', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 4,
          name: '价税合计', // 必传
          value: 'totalPriceAndTax', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 4,
          name: '发票类型', // 必传
          value: 'receiptType', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 4,
          name: '备注', // 必传
          value: 'remark', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 4,
          name: '图片', // 必传
          value: 'imgUrl', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'imageListAll', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        }
      ],
      collectList: [],
      collectTitleList: [
        {
          id: 0,
          name: '供应商名称', // 必传
          value: 'relationEntityName', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 1,
          name: '流水单号', // 必传
          value: 'recordNumber', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true, // 是否不可编辑，true可编辑，false不可编辑
          width: 160
        },
        {
          id: 2,
          name: '付款金额', // 必传
          value: 'transactionMoney', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'priceAccuracy', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 4,
          name: '处理人', // 必传
          value: 'relationPersonName', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 5,
          name: '账户', // 必传
          value: 'accountName', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 5,
          name: '交易时间', // 必传
          value: 'transactionTime', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'dateTime', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 5,
          name: '支付方式', // 必传
          value: 'paymentMethod', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'select', // 必传
          selectOptionKey: 'sys_pay_type', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 6,
          name: '备注', // 必传
          value: 'remark', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        },
        {
          id: 7,
          name: '图片', // 必传
          value: 'imgUrl', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'imageListAll', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: true // 是否不可编辑，true可编辑，false不可编辑
        }
      ],
      // 页面数据
      hrefProData: {},
      singleData: {},
      itemList: [],
      itemListPro: [],
      itemTableBtnList: [],
      flag: false,
      titleList: [
        {
          id: 0,
          name: '入库单号', // 必传
          value: 'purchasesReceiptDocNumber', // 必传
          fixedState: false, // 是否固定     //必传
          isShow: true, // 是否显示          //必传
          dataType: 'text', // 必传
          selectOptionKey: '', // 如果是select下拉框的key 根据字典管理字典类型设置
          selectOptionList: [], // 如果是下拉框 从后台获取下拉框集合
          alwaysEditState: false, // 是否一直处于编辑状态true处于，false不处于
          canEdit: false, // 是否不可编辑，true可编辑，false不可编辑
          width: 90
        },
        {
          id: 1,
          name: '产品编号',
          value: 'baseMaterialNumber',
          fixedState: false,
          isShow: true,
          color: '#1476c3',
          dataType: 'text',
          canEdit: false,
          width: 90
        },
        {
          id: 2,
          name: '产品名称',
          value: 'baseMaterialName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 90
        },
        {
          id: 21,
          name: '产品规格',
          value: 'specifications',
          fixedState: false,
          isShow: true,
          dataType: 'textList',
          canEdit: false,
          width: 200
        },
        {
          id: 7,
          name: '单位',
          value: 'baseMaterialUnitName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 75
        },
        {
          id: 2,
          name: '客户料号', // 必传
          value: 'baseCustomerMaterialNumber', // 必传
          fixedState: false,
          isShow: true,
          dataType: 'text',
          alwaysEditState: false,
          canEdit: false,
          width: 120
        },
        {
          id: 8,
          name: '类型',
          value: 'baseMaterialTypeName',
          fixedState: false,
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 75
        },
        {
          id: 4,
          name: '本次对账数量',
          value: 'baseAmount',
          fixedState: false,
          isShow: true,
          dataType: 'numberAccuracy',
          alwaysEditState: false,
          canEdit: false,
          width: 90
        },
        {
          id: 8,
          name: '单据合同',
          value: 'orderDocContract',
          fixedState: false,
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 75
        },
        {
          id: 8,
          name: '含税单价',
          value: 'baseMaterialUnitprice',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          alwaysEditState: false,
          width: 75
        },
        {
          id: 9,
          name: '未税单价',
          value: 'baseMaterialUnitpriceUntaxed',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          alwaysEditState: false,
          width: 75
        },
        {
          id: 5,
          name: '账单小计(含税)',
          value: 'baseMaterialTotalprice',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 90
        },
        {
          id: 61,
          name: '账单小计(未税)',
          value: 'baseMaterialTotalpriceUntaxed',
          fixedState: false,
          isShow: true,
          dataType: 'priceAccuracy',
          canEdit: false,
          width: 90
        },
        {
          id: 10,
          name: '税率(%)',
          value: 'baseTaxRate',
          fixedState: false,
          isShow: true,
          dataType: 'number',
          canEdit: false,
          alwaysEditState: false
        }
      ],
      examineType: null,
      dialogState: {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        show5: false
      },
      globalSearchDialogData: {},
      materialNumberDialogData: {},
      sysEntityDtoList: [],
      sysEntityExtDto: {},
      tableList: [],
      dialogType: 1,
      dialogStatus: 1,
      dialogTitle: ''
    };
  },
  created() {
    this.hrefProData = this.routeQuery;
    this.getList();
  },
  methods: {
    getList() {
      pmgtPurchasesReceiptDoc_getCooperativeSupplierPurchaseStatementDocView({
        purchasesStatementDocId: this.hrefProData.purchasesStatementDocId
      }).then((res) => {
        this.sysEntityExtDto = res.data.data.sysDocExt;
        this.purchasesStatementDocId = res.data.data.purchasesStatementDocId;
        res.data.data.purchasesStatementDocDetailList.forEach((item) => {
          try {
            item.specifications = JSON.parse(item.baseMaterialSpecDesc);
          } catch (error) {}
        });
        this.itemList = res.data.data.purchasesStatementDocDetailList;
        this.singleData = res.data.data;
        // this.itemGetList();
      });
    },
    itemGetList() {
      pmgtPurchasesStatementDoc_viewWithAccountFlow({
        purchasesStatementDocId: this.hrefProData.purchasesStatementDocId
      }).then((res) => {
        res.data.data.pmgtPurchasesStatementDocVoContainAccountFlowAndSupplierPaymentDetail.forEach(
          (item) => {
            item.createUserName = readUserSelect(item.createUserId);
            item.relationPersonName = readUserSelect(item.relationPersonId);
          }
        );
        this.collectList =
          res.data.data.pmgtPurchasesStatementDocVoContainAccountFlowAndSupplierPaymentDetail;
      });
      pmgtPurchasesStatementDoc_viewWithInvoice({
        purchasesStatementDocId: this.hrefProData.purchasesStatementDocId
      }).then((res) => {
        this.invoiceList = res.data.data.purchasesStatementInvoiceList;
      });
    },
    // 查询菜单Title
    async querySetting() {
      this.sysEntityDtoList = this.$root.sysEntityExt_125;
      let titleList = await selcetSetting('purchase_bill_details');
      if (titleList == null) {
        let listTwo = getObjectFromSessionStorage('resetTitleList_details');
        let listThree = this.$getSysEntityExt(this.$root.sysEntityExt_1, false, false);
        this.titleList = customMenu(listTwo, listTwo, listThree);
        updateSetting(this, 'purchase_bill_details', JSON.stringify(this.titleList));
      } else {
        let listOne = titleList;
        let listTwo = getObjectFromSessionStorage('resetTitleList_details');
        let listThree = this.$getSysEntityExt(this.$root.sysEntityExt_1, false, false);
        this.titleList = customMenu(listOne, listTwo, listThree);
      }
      getSettingByKey({}).then((res) => {
        this.isButtonShow = res.data.data;
        if (this.isButtonShow == 0) {
          this.flag = false;
        } else {
          this.flag = true;
        }
      });
    },
    // 判断审核权限
    getDocExamine() {
      sysDocExamineConfig_canCheckDocByDocType({ docTypeId: 3 }).then((res) => {
        this.examineType = res.data.data;
      });
    },
    customSelectDataShow(val, list) {
      if (list) {
        let single = list.filter((item) => {
          return item.value == val;
        });
        return single.length > 0 ? single[0].label : '';
      }
    },
    // 处理文件附件
    getFileList(list) {
      let count = 0;
      try {
        count = JSON.parse(list).length;
      } catch (error) {
        count = 0;
      }
      return count;
    },
    updateFileList(list, item) {
      // this.sysEntityExtDtoKey = item;
      this.dialogType = 2;
      this.dialogStatus = 1;
      this.dialogTitle = item.fieldName;
      try {
        this.tableList = JSON.parse(list);
      } catch (error) {
        this.tableList = [];
      }
      this.dialogState.show1 = true;
    },
    // 打开excel
    mainExcelOpen(value) {
      const { href } = this.$router.resolve({
        path: '/excelEditV2',
        query: {
          value: value
        }
      });
      window.open(href);
    },
    mainExcelSuccess(row, key, item) {
      let fileInfoId = 0;
      try {
        fileInfoId = JSON.parse(item.fieldTypeRelinfo).fileInfoId;
      } catch (error) {
        fileInfoId = 0;
      }
      let json = {
        fileInfoWithWpsDto: {
          fileInfoId: fileInfoId,
          model: '对账'
        }
      };
      fileInfo_getFileId(json).then((res) => {
        this.sysEntityExtDto[key] = res.data.data;
        this.$forceUpdate();
        let mainSysDocExtDto = {
          extDocId: row.extDocId
        };
        for (let i = 1; i <= 50; i++) {
          // 订单主
          let name1 = 'ext' + i;
          let name2 = 'ext' + i;
          mainSysDocExtDto[name2] = this.sysEntityExtDto[name1];
        }
        sysDocExt_updateByRelId({
          sysDocExtDto: mainSysDocExtDto
        }).then((response) => {
          this.getList();
        });
        const { href } = this.$router.resolve({
          path: '/excelEditV2',
          query: {
            value: res.data.data
          }
        });
        window.open(href);
      });
    },
    // 打开excel
    excelOpen(row, item) {
      const { href } = this.$router.resolve({
        path: '/excelEditV2',
        query: {
          value: row[item.value]
        }
      });
      window.open(href);
    },
    excelSuccess(row, item) {
      let json = {
        fileInfoWithWpsDto: {
          fileInfoId: item.selectOptionList.fileInfoId,
          model: '账单'
        }
      };
      fileInfo_getFileId(json).then((res) => {
        row[item.value] = res.data.data;
        this.$forceUpdate();
        let productExtDto = {
          extEntityId: row.baseMetaMaterialId
        };
        for (let i = 1; i <= 50; i++) {
          // 产品
          let name5 = '1-ext' + i;
          let name6 = 'ext' + i;
          productExtDto[name6] = row[name5];
        }
        sysEntityExt_updateByRelId({
          sysEntityExtDto: productExtDto
        }).then((response) => {
          this.getList();
        });
        const { href } = this.$router.resolve({
          path: '/excelEditV2',
          query: {
            value: res.data.data
          }
        });
        window.open(href);
      });
    },
    examineClick() {
      pmgtPurchasesStatementDoc_checkPmgtPurchasesStatementDoc({
        globalDataId: this.hrefProData.purchasesStatementDocId
      }).then((res) => {
        this.$message.success('操作成功！');
        this.getList();
      });
    },
    formatDate(time) {
      return this.$moment(time).format('YYYY-MM-DD'); // 获取当前时间
    },
    // 计算折扣率
    discountRate() {
      this.singleData.baseShouldInvoiceAmountDiscounted = mulFloat(
        this.singleData.baseShouldPaymentAmount,
        divFloat(this.singleData.baseDiscount, 100)
      );
      this.singleData.baseShouldPaymentAmountDiscounted = mulFloat(
        this.singleData.baseShouldPaymentAmount,
        divFloat(this.singleData.baseDiscount, 100)
      );
    },
    discountMoney() {
      this.singleData.baseDiscount = mulFloat(
        divFloat(
          this.singleData.baseShouldPaymentAmountDiscounted,
          this.singleData.baseShouldPaymentAmount
        ),
        100
      );
    },
    updateClick() {
      pmgtPurchasesStatementDoc_update({
        sysDocExtDto: this.sysEntityExtDto,
        pmgtPurchasesStatementDocDto: this.singleData,
        pmgtPurchasesStatementDocDetailDtoList: this.itemList
      }).then((res) => {
        this.$message.success('操作成功！');
      });
    },
    backHome() {
      // this.$router.back();
      this.$emit('backHome');
      // this.$router.push({
      //   path: "/main/purchase_bill",
      //   query: {},
      // });
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
      updateSetting(this, 'purchase_bill_details', JSON.stringify(this.titleList));
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
      updateSetting(this, 'purchase_bill_details', JSON.stringify(this.titleList));
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
      updateSetting(this, 'purchase_bill_details', JSON.stringify(this.titleList));
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
      updateSetting(this, 'purchase_bill_details', JSON.stringify(this.titleList));
    },
    // 重置
    async resetClick(titleList) {
      let listTwo = getObjectFromSessionStorage('resetTitleList_details');
      let listThree = this.$getSysEntityExt(
        [...this.$root.sysEntityExt_122, ...this.$root.sysEntityExt_1],
        false,
        false
      );
      this.titleList = [...listTwo, ...listThree];
      this.titleList = this.$customStyleMenu(titleList, this.titleList);
      updateSetting(this, 'purchase_bill_details', JSON.stringify(this.titleList));
    },
    // click global search number
    click_globalSearchNumber() {
      this.globalSearchDialogData = this.singleData;
      this.dialogState.show4 = true;
    },
    // table click cell event
    cellClickEvent(row, column) {
      switch (column.field) {
        case 'baseMaterialNumber':
          this.materialNumberDialogData = row;
          this.dialogState.show5 = true;
          break;
        default:
          break;
      }
    },
    dialogClose() {
      this.dialogState = {
        show1: false,
        show2: false,
        show3: false
      };
    }
  }
};
</script>
<style scoped>
.input {
  width: 180px;
  margin-right: 20px;
}

.btnOne {
  background: #1476c3;
  color: white;
}

.span {
  margin-right: 20px;
  color: #1476c3;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
      justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.checkImg {
  height: 75px;
  width: 150px;
  position: absolute;
  top: 50px;
  right: 20px;
  z-index: 99;
  /* opacity: 0.5; */
  transform: rotate(-10deg);
}

.turnToPointer {
  cursor: pointer;
}
</style>
